import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { BookAppointment } from '@grandvisionhq/forms';
import { useFeatureToggles } from '@grandvisionhq/state';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import { parseBloomreachInputField } from '../../utils/parse-bloomreach-input-field.js';
import { useBloomreachLinks } from '../../hooks/use-bloomreach-links.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsWidget = ({ content , template , meta  })=>{
    const { isGpsStoresEnabled , isStoresPlacePredictionsEnabled  } = useFeatureToggles();
    const { title , links , inputField , image , content: text  } = content;
    const [link] = useBloomreachLinks(links);
    const input = parseBloomreachInputField(inputField);
    if (!input || !link) {
        return null;
    }
    switch(template){
        case 'book-eye-check':
        case 'book-appointment':
            return /*#__PURE__*/ React.createElement(BookAppointment, {
                title: title,
                link: link,
                inputField: input,
                isLocationEnabled: isGpsStoresEnabled,
                isPlacePredictionsEnabled: isStoresPlacePredictionsEnabled
            });
        case 'book-appointment-extended':
            return /*#__PURE__*/ React.createElement(BookAppointment, {
                title: title,
                link: link,
                inputField: input,
                isLocationEnabled: isGpsStoresEnabled,
                isPlacePredictionsEnabled: isStoresPlacePredictionsEnabled,
                text: text === null || text === void 0 ? void 0 : text.value,
                imageUrl: image === null || image === void 0 ? void 0 : image.url,
                backgroundColor: (meta === null || meta === void 0 ? void 0 : meta.backgroundColorHex) || (meta === null || meta === void 0 ? void 0 : meta.backgroundColor),
                textColor: meta === null || meta === void 0 ? void 0 : meta.textColor
            });
        default:
            return /*#__PURE__*/ React.createElement(Heading, {
                variant: "subheading1"
            }, "Widget of type: ", template, " is not defined.");
    }
};
var CmsWidget$1 = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsWidget);

export { CmsWidget, CmsWidget$1 as default };
//# sourceMappingURL=Widget.js.map
